import { log } from '@/log'

export type CvsType =
    'seven-eleven' |
    'familymart' |
    'lawson' |
    'ministop' |
    'seicomart'

export function getCvsTypeLabel(cvsType: CvsType): string {
  switch (cvsType) {
    case 'seven-eleven':
      return 'セブンイレブン'
    case 'familymart':
      return 'ファミリーマート'
    case 'lawson':
      return 'ローソン'
    case 'ministop':
      return 'ミニストップ'
    case 'seicomart':
      return 'セイコーマート'
    default:
      log.error(`invalid cvsType: ${cvsType}`)

      return ''
  }
}
